import { all } from 'redux-saga/effects';
import authWatcher from './auth/watcher';
import claimWatcher from './claim/watcher';

export default function* rootSaga() {
    yield all([...authWatcher, ...claimWatcher]);
}
